import SingleBallotMatchFormContainer from './SingleBallotMatchFormContainer';

export default SingleBallotMatchFormContainer;
